import React from 'react'
import { Field } from '@ztechapps/webui.form'
import { TaskTemplateInputComponent } from './TaskTemplateInputComponent'

export const TaskTemplateValueInput = () => {
  return (
    <Field
      {...{
        name: 'value',
        rows: 10,
        component: TaskTemplateInputComponent,
        onChange: true,
      }}
    />
  )
}
